<template>
    <div>
<section class="page-title">
    <v-img 
        height="250"        
        :src="require('@/Content/images/cliente.png')"
        class="white--text"
        gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
        max-width="100%"
                  
      >
      <div class="center  more-padding">
        <h1 class="the-title" ><span >Área </span>do Cliente</h1>
    </div>
    </v-img>
        </section>          
        <section class="page-content center" v-if="!userloggedin">
            <div class="login-form">                
                <p class="label-form">Acesse Agora</p>
                <div class="validation-summary-valid" data-valmsg-summary="true"><ul><li style="display:none"></li>
        </ul></div>
                <label for="Email">E-mail</label>
                <v-text-field
                    style="border-radius:10px;"
                    solo
                    flat
                    v-model="email"
            ></v-text-field> 
            <div v-if="!showAlterPass">              
                <label for="Password">Senha</label>
                <v-text-field
                    type="password"
                    style="border-radius:10px;"
                    v-model="password"
                    solo
                    flat
                    @keydown.enter="signin"
            ></v-text-field>
            </div> 
                <div class="footer-login-form">
                    <a class="blind-button" href @click.prevent="showAlterPass = !showAlterPass">
                        <span v-if="!showAlterPass">Esqueci minha senha</span>
                        <span v-else>Voltar</span>
                    </a>
                    <button v-if="!showAlterPass" class="login-button" @click="signin">Entrar</button>
                    <button v-else class="login-button" @click="recover">Recuperar Senha</button>
                </div>
            </div>
        </section>    
<section class="resumo page-content center" style="padding: 27px 0;" v-else>

        <ConteudoCliente />  
    </section>
    <v-dialog v-model="dialog" max-width="650px" persistent> 
      <v-card> 
        <v-container
            fluid
            justify-center
            grid-list-md
          >
        <v-card-title>
          <span class="headline" style="color:#7593b4;">Primeiro Acesso</span>
        </v-card-title>
        <v-card-text style="color:#546e7a;">Para realizar o primeiro acesso é necessário  <span style="font-weight: bold">alterar a senha:</span></v-card-text>
        <v-layout row wrap>
        <v-flex xs12 sm12 lg4>           
        <v-text-field
            v-model="password"
            label="Senha Atual*"
            v-validate="'required'"
            :error-messages="errors.collect('senhaAtual')"
            ref="password"
            data-vv-name="senhaAtual"
            outline
            disabled
            :append-icon="exibeSenhaAtual ? 'visibility' : 'visibility_off'"
            :type="exibeSenhaAtual ? 'text' : 'password'"
            @click:append="exibeSenhaAtual = !exibeSenhaAtual"
    ></v-text-field>
    </v-flex>
        <v-flex xs12 sm12 lg4>           
        <v-text-field
            v-model="resetPassword"
            label="Nova Senha*"
            v-validate="'required'"
            :error-messages="errors.collect('senha')"
            ref="password"
            data-vv-name="senha"
            outline
            :append-icon="exibeSenhaNova ? 'visibility' : 'visibility_off'"
            :type="exibeSenhaNova ? 'text' : 'password'"
            @click:append="exibeSenhaNova = !exibeSenhaNova"
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            
            v-model="confirmPassword"
            label="Repetir Senha*"
            :error-messages="errors.collect('password')"
            v-validate="'required|confirmed:password'"
            data-vv-name="password"
            outline
            :append-icon="exibeSenhaRepeticao ? 'visibility' : 'visibility_off'"
            :type="exibeSenhaRepeticao ? 'text' : 'password'"
            @click:append="exibeSenhaRepeticao = !exibeSenhaRepeticao"
            @keydown.enter="alterarSenha"
            ></v-text-field>
            </v-flex>
            </v-layout>
        </v-container>
     
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="close">Cancelar</v-btn>
          <v-btn color="#7593b4" style="border-radius: 8px; width: 130px;" dark @click.native="alterarSenha">Alterar Senha</v-btn>          
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="selectProposal" v-if="!this.tempPassword" max-width="650px" max-height="500px" persistent> 
      <v-card style="border-radius: 10px;">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Olá, {{nomeUsuario}}!</span>              
              </v-card-title>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                    class="resumo"                    
                  >
                <p style="font-weight: bold;">Selecione uma proposta abaixo.</p>
              </v-container>
            </v-layout>
            <v-card-actions style="margin: 25px auto auto auto;">
              <v-container
                fill-height
                fluid
                pa-1
                justify-center
              >
               
                <v-data-table
                :headers="headers"
                :items="fmRegisteredProposal"
                class="elevation-1"                
                rows-per-page-text="Linhas por página"
                :pagination.sync="pagination"
                >
                  <template v-slot:items="props">
                    <td style="padding-top: 10px; font-weight: bold; font-size: 13px" @click="goToProposal(props.item)">{{ props.item.created }}</td>
                    <td style="padding-top: 10px; font-weight: bold; color: orange; font-size: 18px" @click="goToProposal(props.item)">{{ props.item.proposalNumber }}</td>                      
                  </template>

                </v-data-table> 
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" 
        :can-cancel="true" 
        color="#446fb5"
        :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
import ConteudoCliente from '../views/ConteudoCliente.vue'
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
import { mapState } from 'vuex'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components: {Snackbar, ConteudoCliente, Loading},
     data(){
        return{
            pagination: {'sortBy': 'created', descending: true, 'rowsPerPage': 10},
            headers: [
              {
                text: 'DATA E HORA',
                align: 'center',
                value: 'created',                
              },
              { 
                text: 'NÚMERO DA PROPOSTA', 
                align: 'center', 
                value: 'proposalNumber' 
              }   
            ],
            selectedItem: 0,
            selectProposal: false,
            fullPage: true,  
            isLoading: false,
            exibeSenhaAtual: false,
            exibeSenhaNova: false,
            exibeSenhaRepeticao: false,
            financialManager: [],
            fmRegisteredProposal: [],
            tempPassword: false,
            dialog: false,
            rowsPerPageItems: [1, 12, 18],
            showAlterPass: false,
            email: '',
            password: '',
            resetPassword: '',
            confirmPassword: '',
            activeBtn: 'Propostas',
            nomeUsuario: '',
            proposta: [],
            propostaPendente: false,
            propostas: false,
            boletos: false,
            carteirinha: false,
            dictionary: {          
                custom: {              
                password: {
                    required: () => 'Informe a Senha',
                    confirmed: () => 'A senha não confere'
                },
                senha: {
                    required: () => 'Informe a Senha'
                },
                senhaAtual: {
                    required: () => 'Informe a Senha'
                }
               
            }
            }
        }
    },
    computed: mapState({
        userloggedin: state => state.userloggedin,
    }),
    mounted : function(){
      this.$store.dispatch('Logar')
      this.$store.dispatch('ExibeToolbar')
      if(localStorage.getItem('user') != null)
      this.proposta = JSON.parse(localStorage.getItem('proposta') || '[]')
      if(sessionStorage.getItem('email') != null)
      this.email = sessionStorage.getItem('email')
      this.setProposta()
      this.$validator.localize('pt', this.dictionary)
    },
    methods: {
       async signin() {
         var proposta0 = ''
         var hasUser = false
         this.isLoading = true
           localStorage.clear()
           sessionStorage.clear()           
          await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"email": this.email}).then(res => {      
            if(res.data != ''){ 
              hasUser = true  
              proposta0 = res.data[0] 
              this.isLoading = false              
              this.financialManager = res.data
              if(this.financialManager.tempPassword == undefined || this.financialManager.tempPassword == false) 
              this.tempPassword = false 
              else
              this.tempPassword = true          
              if(this.tempPassword){
                  this.nomeUsuario = res.data.firstName  
                  this.proposta = res.data
                  this.openDialog()
              }
                            
            }
            else{              
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Usuário/Senha incorreto!","ERRO");
            }
           })  
           
           this.nomeUsuario = proposta0.firstName
           if (hasUser) {
              await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"email": this.email}).then(res => {
              if(res.data.length > 1){
                this.fmRegisteredProposal = res.data  
                for (let i in res.data) {
                  this.fmRegisteredProposal[i].created = this.formatDate(res.data[i].created)
                }                         
                this.selectProposal = true
              }
              else
              if(this.tempPassword == false) {   
                this.isLoading = false
                sessionStorage.setItem('email', this.email)
                this.$store.dispatch('Logar')                    
                this.proposta = proposta0                       
                localStorage.setItem('proposta', JSON.stringify(proposta0))
              }
              
            })
          }

        },

        async goToProposal(dados) { 
          if (dados.tempPassword) {
            var alteradoTempPassword = {
              "tempPassword": false,
              "id": dados.id
            }
            try {
              await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', alteradoTempPassword)
              
            } catch (error) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao realizar ação. Tente novamente.","ATENÇÃO");
            }
          }
          this.isLoading = false
          this.selectProposal = false
          sessionStorage.setItem('email', this.email)
          this.$store.dispatch('Logar')                    
          localStorage.setItem('proposta', JSON.stringify(dados))         
        },

        formatDate (data) {          
          var date = data.substr(0, 10).split('-')          
          date = date[2] + '/' + date[1]          
          var hour = data.substr(11, 5)                  
          var dataFormatada = date + ' ÀS ' + hour
          return dataFormatada
        },

        async recover() {
          var vm = this
            localStorage.clear()
            sessionStorage.clear()
            if (this.email) {
              this.isLoading = true
              try {
                let res = await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"email": this.email})
                if (res.data != '') {
                  this.financialManager = res.data
                  this.reenviaEmail()
                } else {
                  this.isLoading = false
                  vm.$refs.chamaSnackbar.snack("#F9A825","Email não localizado!","ATENÇÃO");
                }
              } catch (error) {
                this.isLoading = false

                vm.$refs.chamaSnackbar.snack("#F9A825","Email não localizado!","ATENÇÃO");
              }
            } else {
              vm.$refs.chamaSnackbar.snack("#F9A825","Informe um e-mail!","ATENÇÃO");


            }
        },

    async reenviaEmail()
    {
      try {
        let res = await axios.post(`${baseApiUrl}Sales/SendEmailProposalCreate`,{"id": this.financialManager[0].id})
        if(res.data != '')
        {
          this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1","Um email foi enviado para " + this.financialManager[0].email + ", com uma nova senha temporária!","INFORMAÇÃO");
        }
      } catch (error) {
        this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao enviar email, tente novamente!","ERRO");
      }

    },

    openDialog(){
        this.dialog = true
      },
    close(){
        this.dialog = false
        this.resetPassword = ''
        this.confirmPassword = ''
      },

        setProposta(){
        this.propostas = true
        this.boletos = false
        this.carteirinha = false
      },
      setBoletos(){
        this.propostas = false
        this.boletos = true
        this.carteirinha = false
      },
      setCarteirinha(){
        this.propostas = false
        this.boletos = false
        this.carteirinha = true
      },
      async alterarSenha(){
          if(this.confirmPassword == '' || this.resetPassword == '' || this.confirmPassword != this.resetPassword)
            this.$validator.validateAll()
            else{
                axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, {"id": this.financialManager.id,'password':this.resetPassword,'confirmPassword':this.confirmPassword,'tempPassword':false}).then(res => {         
                if(res.data != ''){
                      this.close()
                      sessionStorage.setItem('email', this.email)
                      this.$store.dispatch('Logar')         
                      localStorage.setItem('proposta', JSON.stringify(this.proposta))
                      var vm = this;
                      vm.$refs.chamaSnackbar.snack("#0288D1","Senha alterada com sucesso!","INFORMAÇÃO");         
                  }              	
                  })
            }
      }
    }

}
</script>

<style scoped>
   
    .elevation-1 {
      cursor: pointer;
    }

    td {
      text-align: center !important;
    }

    .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
      border-radius: 10px;
    }
    .informativo {
    font-size: 25px;
    color: #105586;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;    
  }
</style>
